export enum GenderEnum {
  NOT_KNOWN = 0,
  MALE = 1,
  FEMALE = 2,
  NOT_APPLICABLE = 9,
}
